import { LKDate } from 'loankeeper-common/helpers/Date'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_restructurizations',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,
  selectLastRow: true,

  columnDefs: [
    { headerName: 'RestructureDate', field: 'RestructureDate' },
    { headerName: 'LoanAmount', field: 'LoanAmount' },
    { headerName: 'Reschedule', field: 'Reschedule' },
  ],

  columnConfigs: {
    RestructureDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },
  },
}

export default config
